import { MenuItem } from "@mui/material";
import FormikSelect from "../FormikSelect";


// Name location Fields contiene la lista de nombres de los campos a utilizar
const FormikPais = ({ label, nameLocationFields }) => {
    const listaPais = [{ id: "1", nombre: "Argentina" }];

    return (
        <FormikSelect
            name={nameLocationFields.pais}
            label={label ? label : "País *"}
            variant="standard"
            fullWidth
        >
            {listaPais.map(({ id, nombre }) => (
                <MenuItem value={id} key={id}>
                    {nombre}
                </MenuItem>
            ))}
        </FormikSelect>

    )
}

export default FormikPais;